import { useFeatureFlags, useUpdateFeatureFlag } from '@/hooks/use-settings'
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card'
import { Switch } from '@/components/ui/switch'
import { Label } from '@/components/ui/label'

export function FeatureFlagsSettings() {
  const { data: flags, isLoading, error } = useFeatureFlags()
  const updateFlag = useUpdateFeatureFlag()

  const handleToggle = (key: string, enabled: boolean) => {
    updateFlag.mutate({ key, enabled })
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>Feature Flags</CardTitle>
        <CardDescription>
          Enable or disable experimental features
        </CardDescription>
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <div className="space-y-3">
            <div className="h-20 bg-muted animate-pulse rounded" />
            <div className="h-20 bg-muted animate-pulse rounded" />
            <div className="h-20 bg-muted animate-pulse rounded" />
          </div>
        ) : error ? (
          <div className="text-sm text-destructive">
            Failed to load feature flags. Please try again.
          </div>
        ) : (
          <div className="space-y-3">
            {flags?.map((flag) => (
              <div
                key={flag.key}
                className="flex items-center justify-between rounded-lg border p-4"
              >
                <div className="flex-1">
                  <Label htmlFor={flag.key} className="font-medium cursor-pointer">
                    {flag.name}
                  </Label>
                  <p className="text-sm text-muted-foreground">
                    {flag.description}
                  </p>
                </div>
                <Switch
                  id={flag.key}
                  checked={flag.enabled}
                  onCheckedChange={(enabled) => handleToggle(flag.key, enabled)}
                  disabled={updateFlag.isPending}
                />
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  )
}
